import { render, staticRenderFns } from "./SerialNumbers.vue?vue&type=template&id=9a0dda84"
import script from "./SerialNumbers.vue?vue&type=script&lang=js"
export * from "./SerialNumbers.vue?vue&type=script&lang=js"
import style0 from "./SerialNumbers.vue?vue&type=style&index=0&id=9a0dda84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports